import { useGetBuhHandlings } from 'queries';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';

export const useGetBuhHandlingOptions = () => {
  const { data, isError } = useGetBuhHandlings();

  if (isError) {
    return [];
  }

  return (
    (data?.map((item) => ({
      value: item.code,
      label: item.name
    })) as Option[]) ?? []
  );
};
